import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { ShellLayoutComponent } from "./layout/layout.component";
import { WelcomeComponent } from "./welcome/welcome.component";

const routes: Routes = [
    {
        path: '',
        component: ShellLayoutComponent,
        children: [
            {
                path: '',
                children: [
                    { path: '', component: WelcomeComponent },
                    { path: 'welcome', component: WelcomeComponent }
                ]
            },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ShellRoutingModule { }
